import { useCallback } from "react";
import { Haptics, ImpactStyle, NotificationType } from "@capacitor/haptics";

import { createLogger } from "../utils/logger";

const logger = createLogger("useHaptics");

type HapticPattern =
  | "light"
  | "medium"
  | "heavy"
  | "success"
  | "warning"
  | "error"
  | number;

export function useHaptics() {
  return useCallback(async (pattern: HapticPattern = "light") => {
    try {
      if (typeof pattern === "number") {
        await Haptics.vibrate({ duration: pattern });
        return true;
      }

      switch (pattern) {
        case "light":
          await Haptics.impact({ style: ImpactStyle.Light });
          break;
        case "medium":
          await Haptics.impact({ style: ImpactStyle.Medium });
          break;
        case "heavy":
          await Haptics.impact({ style: ImpactStyle.Heavy });
          break;
        case "success":
          await Haptics.notification({ type: NotificationType.Success });
          break;
        case "warning":
          await Haptics.notification({ type: NotificationType.Warning });
          break;
        case "error":
          await Haptics.notification({ type: NotificationType.Error });
          break;
      }
      return true;
    } catch (error) {
      // Haptics are enhancement-only; logging at debug to reduce noise if unavailable
      logger.debug("Haptics execution failed (likely not supported on this platform)", error);
      return false;
    }
  }, []);
}
